<form (ngSubmit)="create()" autocomplete="off">
    <app-card headline="Create User">
        <app-card-body>
            <div style="padding: 20px">
                <app-edit-user-inner
                    [user]="user"
                    (formIsValid)="formIsValid($event)"
                    newUser="true"
                    (formIsDirty)="innerFormIsDirty($event)"
                ></app-edit-user-inner>
            </div>
        </app-card-body>
        <app-card-footer>
            <div class="btn-group float-right">
                <button class="btn btn-primary" [disabled]="!inputValid">
                    Create User
                </button>
                <button class="btn btn-outline-secondary" (click)="cancel()">
                    Cancel
                </button>
            </div>
        </app-card-footer>
    </app-card>
</form>
